import { render } from "./VoiceLedgerCard.vue?vue&type=template&id=77bd9cc5&scoped=true"
import script from "./VoiceLedgerCard.vue?vue&type=script&lang=js"
export * from "./VoiceLedgerCard.vue?vue&type=script&lang=js"

import "./VoiceLedgerCard.vue?vue&type=style&index=0&id=77bd9cc5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bd9cc5"]])

export default __exports__